import { makeStyles, Theme } from "@material-ui/core/styles";
import { RefObject, useEffect, useState } from "react";
import { sleepAsync } from "../../../../../../../common/functions";
import { openOtherUserPanel } from "../../../../../User/OtherUserPanel/functions";
import { UserForRanking } from "../../../../../User/types";
import { UserAvatar } from "../../../../../User/UserAvatar/UserAvatar";
import { UsersConnectionHeightList } from "../../types";

export function LeftAvatarArea({
    postedUser,
    avatarRef,
    usersConnectionHeightList,
    connectionTop,
    connectionLeft,
    connectionWidth,
}: {
    postedUser?: UserForRanking;
    avatarRef: RefObject<HTMLDivElement>;
    usersConnectionHeightList: UsersConnectionHeightList;
    connectionTop: number;
    connectionLeft: number;
    connectionWidth: number;
}) {
    const c = useStyles();
    return (
        <div className={c.container}>
            <UserAvatar
                user={postedUser}
                colorNumber={postedUser?.userId ?? "noColor"}
                size={40}
                onClick={ev => {
                    ev.stopPropagation();
                    if (!postedUser) {
                        return;
                    }
                    openOtherUserPanel(postedUser.userId);
                }}
                className={postedUser ? "pointer" : undefined}
                avatarRef={avatarRef}
            />

            {Object.entries(usersConnectionHeightList).map(
                ([commentNo, height]) =>
                    Number(commentNo) > 0 ? (
                        <UsersConnection
                            key={commentNo}
                            height={height}
                            top={connectionTop}
                            left={connectionLeft}
                            width={connectionWidth}
                        />
                    ) : null
            )}
        </div>
    );
}
export const postLeftAvatarAreaWidth = 53;
const useStyles = makeStyles({
    container: {
        width: postLeftAvatarAreaWidth,
        minWidth: postLeftAvatarAreaWidth,
        display: "flex",
        flexDirection: "column",
    },
});

const speed = 2;
function UsersConnection({
    height,
    width,
    top,
    left,
}: {
    height: number;
    width: number;
    top: number;
    left: number;
}) {
    const [mounted, setMounted] = useState(false);
    const [afterMounted, setAfterMounted] = useState(false);

    const heightTime = Math.ceil(height * speed);
    const widthTime = Math.ceil(width * speed);
    useEffect(() => {
        setMounted(true);
        sleepAsync(heightTime + widthTime).then(() => {
            setAfterMounted(true);
        });
    }, [heightTime, widthTime]);

    const c = useUsersConnectionStyles({
        mounted,
        afterMounted,
        top,
        left,
        height,
        width,
        heightTime,
        widthTime,
    });

    return <div className={c.connection} />;
}
const useUsersConnectionStyles = makeStyles<
    Theme,
    {
        mounted: boolean;
        afterMounted: boolean;
        top: number;
        left: number;
        height: number;
        width: number;
        heightTime: number;
        widthTime: number;
    }
>(theme => ({
    connection: ({
        mounted,
        afterMounted,
        top,
        left,
        height,
        width,
        heightTime,
        widthTime,
    }) => {
        const borderStyle = `solid 2px ${theme.palette.grey[400]}`;
        const size = mounted ? { height, width } : { height: 0, width: 0 };
        return {
            position: "absolute",
            top,
            left,
            ...size,
            transition: afterMounted
                ? undefined
                : `height ${heightTime}ms linear, width ${widthTime}ms linear ${heightTime}ms`,
            borderLeft: borderStyle,
            borderBottom: borderStyle,
            borderBottomLeftRadius: 20,
        };
    },
}));
